const $btn = $(".js-additional-btn");
const $additional = $btn.parent().siblings().find(".additional");

$btn.on("click", function (e) {
  const $this = $(this);

  $additional.addClass("is-active");
  $this.hide();

  e.preventDefault();
});
